// Configuration file for environment variables
const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || '',

  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',

  // App Configuration
  APP_NAME: 'Mabrouk Events',

  // Default timeout for API calls
  API_TIMEOUT: 10000,
};

export default config;
